import React, { useState } from 'react'
import { useApp } from '../../../context/app-context';
import { Typography, Form, Input, Button, Divider, Space, Row, Radio } from 'antd';
import { AccessTable } from './AccessTable.component';
import { updateUser } from '../../../services/UserService';
import { isValidPhoneNumber, maskPhoneNumber, validatePhoneNumber } from '../../../Validation';
import { AccountSettings } from './AccountSettings.component';
import { useMessage } from '../../UI/MessageProvider';

const { Title }  = Typography;

export const EditInformationForm = ({ account, isAdmin, locations, accesses, ...props }) => {

    const { state: {user}} = useApp();
    const { dispatch } = useApp();
    const message = useMessage();
    
    const [form] = Form.useForm();

    const accessType = (account?.Accesses ? account?.Accesses[0]?.accessType : []) ;
    const [ privilege, setPrivilege ] = useState(accessType);
    // Default values (accesses)
    const [selectedRowKeys, setSelectedRowKeys] = useState(accesses);

    const resetUserPasswordBtn =  <Button danger type='secondary'>Reset user password</Button>;

    const onChange = e => {
        setPrivilege(e.target.value);
    }

    const onFinish = (data) => {
        if( isAdmin ) {
            Object.assign(data, {access: selectedRowKeys})
        }
        
        Object.assign(data, {userID: account.id})
        updateUser(data).then( function (response) {

            if(Object.hasOwn(response, 'result') && !response.result){
                return  message.error(response.message, 3);
            }

            if (!Object.hasOwn(response, 'result') && response.message) {
                message.success(response.message, 3);
                
                // Update information of logged-in user
                if(!account.locations && !account.Accesses){
                    let {devicesExpandable, siteExpandable} = data;
                    Object.assign(data, {settings: {devicesExpandable, siteExpandable}})
                    dispatch({type: 'update-user', payload: {...user, ...data}})
                }

                // If form is being used to edit an user on Access Management screen 
                if(props.location) {
                    if(props.location.pathname === '/app/edit-user'){
                        props.setCurrentUser({...account, ...data});
                    }
                }
                return;
            }
            message.error(response.message);
        })
    }

    const getInitialValues = () => {
        if(!account.locations && !account.Accesses){
            return user
        } else {
            return account
        }
    }

    const resetForm = () => {
        form.resetFields();
        setSelectedRowKeys(accesses);
    }

    return(
        <>
            <div className='account__edit-info'>
                <div className='account__edit-form-container'>
                <Title level={5}>Edit Information</Title>
                    <Form 
                        form={form}
                        autoComplete='off'
                        name="edit-account-info-form"
                        layout="vertical"
                        onFinish={(values) => onFinish(values)} 
                        initialValues={getInitialValues()}
                    >
                        <Form.Item name="username" label="Username:">
                            <Input disabled placeholder="username" />
                        </Form.Item>

                        <Form.Item name="firstName" label="First name:">
                            <Input/>
                        </Form.Item>

                        <Form.Item name="lastName" label="Last name:">
                            <Input/>
                        </Form.Item>

                        <Form.Item name="email" label="Email address:">
                            <Input type="email" />
                        </Form.Item>

                        <Form.Item 
                                label='Phone number:' 
                                name='phone' 
                                hasFeedback
                                validateTrigger='onChange'        
                                rules={[
                                    {
                                        required: false,
                                        message: 'Phone number is required.',
                                    },
                                    {
                                        validator: (rule, value) => {
                                            
                                            if(!rule.required && !value){
                                                return Promise.resolve();
                                            }

                                            if (value && validatePhoneNumber(value) && isValidPhoneNumber(value)) {
                                                return Promise.resolve();
                                            }
                                            
                                            return Promise.reject(new Error('Enter valid phone number.'));
                                            }
                                        },
                                    ]}     
                                >
                                <Input className='no-spinner' onInput={e => maskPhoneNumber(e)}/>
                            </Form.Item>

                        <AccountSettings form={form}/>
                        
                        { isAdmin && <>
                            <Divider/>
                            <Title level={5}>Manage Permissions</Title>
                            <Form.Item name="privilege" initialValue={accessType}>
                                <Radio.Group onChange={onChange} >
                                    <Radio value="W"><span className="radio__label">Read/Write</span> <br/>Give users permissions to create, modify, and delete sites and devices under the sites specified to them.</Radio>
                                    <Radio value="R"><span className="radio__label">Read only</span> <br/> Users can view information and status of the sites and devices under the sites but cannot make changes. They also cannot create or delete new or existing sites and devices.</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </>}

                        

                        { isAdmin &&
                            account.userType === 'T' && <AccessTable data={locations} selectedRowKeys={selectedRowKeys} setSelectedRowKeys={setSelectedRowKeys}/>
                        }

                        <Row justify='start' style={{marginTop: 30}}>
                            <Space>
                                <Form.Item>
                                    {/* {isAdmin ? resetUserPasswordBtn : ''} */}
                                    <Button type="primary" htmlType="submit">Save Changes</Button>
                                </Form.Item>
                                <Form.Item>
                                    <Button onClick={() => resetForm()}>Cancel</Button>
                                </Form.Item>
                            </Space>
                        </Row>
                        
                    </Form>
                </div>
            </div>
        </>
    )
};